"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuIcon;
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Badge = _interopRequireDefault(require("@mui/material/Badge"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Popover = _interopRequireDefault(require("@mui/material/Popover"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _Box = _interopRequireDefault(require("@mui/system/esm/Box/Box.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Close = _interopRequireDefault(require("../icons/Close"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _makeStyles.default)(theme => ({
  activeIconButton: {
    backgroundColor: theme.palette.action.hover
  },
  badge: {
    right: '80%',
    borderRadius: '5px',
    height: '16px',
    minWidth: '16px',
    fontWeight: 300
  }
}));
/**
 * Popover component that opens children content with tooltip and badge
 */
function MenuIcon(props) {
  const {
    closeButton = false,
    badge,
    badgeProps,
    buttonProps,
    children,
    icon,
    disabled,
    noPadding,
    open,
    onClose,
    onClick,
    popoverProps,
    title,
    tooltip,
    tooltipProps
  } = props;
  const classes = useStyles({
    noPadding
  });
  const [openPopover, setOpenPopover] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setOpenPopover(open || false);
  }, [open]);
  const togglePopover = state => {
    // uncontrolled popover
    if (children && open === undefined) setOpenPopover(state);
  };
  const closePopper = e => {
    e.stopPropagation();
    togglePopover(false);
    if (onClose) onClose(e);
  };
  const anchorRef = (0, _react.useRef)(null);
  const handleIconClick = e => {
    if (anchorRef.current) anchorRef.current.blur();
    togglePopover(true);
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      disableInteractive: true,
      title: !disabled && tooltip || '',
      disableHoverListener: !Boolean(tooltip),
      ...tooltipProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        ref: anchorRef,
        sx: {
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        },
        className: (0, _classnames.default)({
          [classes.activeIconButton]: openPopover
        }),
        onClick: handleIconClick,
        disabled: disabled,
        ...buttonProps,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge.default, {
          invisible: !badgeProps && !Boolean(badge && !disabled),
          badgeContent: badge,
          color: "secondary",
          classes: {
            badge: badgeProps?.variant !== 'dot' ? classes.badge : undefined
          },
          ...badgeProps,
          children: icon
        })
      })
    }), children ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Popover.default, {
      open: openPopover,
      anchorEl: anchorRef.current,
      onClose: closePopper,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      ...popoverProps,
      PaperProps: {
        ...popoverProps?.PaperProps,
        sx: {
          ...defaultPaperStyles,
          p: noPadding ? 0 : 1,
          ...popoverProps?.PaperProps?.sx
        }
      },
      children: [(title || closeButton) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        sx: {
          display: 'flex',
          justifyContent: 'space-between',
          p: noPadding ? 1 : 0
        },
        children: [title && typeof title === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "h6",
          children: title
        }) : title, closeButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          sx: {
            padding: '4px',
            marginLeft: '15px'
          },
          color: "inherit",
          onClick: closePopper,
          size: "large",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {})
        }) : null]
      }), children]
    }) : null]
  });
}
const defaultPaperStyles = {
  overflow: 'visible',
  boxShadow: '0 6px 20px 0 rgba(0, 0, 0, 0.3)',
  maxHeight: '90%'
};